export default __webpack_public_path__ + "static/media/missing-image.6dde57a1.jpg";